module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-br":{"formats":{"date":"##/##/####","datetime":"##/##/#### ##:##"},"validation":{"invalid_date":"Data inválida","required":"Este campo é obrigatório","invalid_format":"Formato inválido"}}}')
  delete Component.options._Ctor
}
